<template>
  <div class="layout">
    <div class="sidebar"><Sidebar /></div>
    <div class="layout-container">
      <div class="fixed-top">
        <!-- 右侧 用户 -->
        <div class="rightDiv">
          <!-- logo -->
          <div class="leftDiv" style="margin-left: 40px">
            <div class="logo" @click="logoFun">
              <svg-icon
                icon-class="logo_main"
                style="font-size: 145px; height: 40px"
              />
            </div>
          </div>
          <div class="bell">
            <SystematicNotification />
          </div>
          <div class="system-switch">
            <div
              v-for="(item, index) in switchList"
              :key="index"
              class="switch-item"
            >
              <span v-handle="item.role">
                <span>{{ item.remark + "：" }}</span>
                <el-switch
                  v-model="item.switchFlag"
                  @change="changeSwitch($event, item)"
                  :active-value="false"
                  :inactive-value="true"
                ></el-switch>
              </span>
            </div>
            
            <div class="switch-item" v-handle="countFailBtn">
              <el-badge :value="failProcessingTotal" :max="99" class="item">
                <el-tooltip content="点击刷新" placement="top">
                  <el-button type="warning" @click="countFailProcessingOrder(1)" v-loading="loadingCountFail">待退款</el-button>
                </el-tooltip>
              </el-badge>
            </div>
          </div>
          <el-dropdown size="large" class="avatar-container" trigger="click">
            <div class="avatar-wrapper">
              <div class="user">
                <div class="squert">
                  <!-- <svg-icon icon-class="defaulthead" class="user-img" /> -->
                </div>
                <div class="text">{{ userName }}</div>
                <i class="el-icon-caret-right"></i>
              </div>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                ><div @click="goRoute">我的首页</div></el-dropdown-item
              >
              <el-dropdown-item
                ><div @click="goOut">退出登录</div></el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <tabs class="tabs" />
      </div>
      <div class="main-container">
        <div class="container-div">
          <div class="container">
            <!-- <router-view v-if="$route.meta.noKeepAlive" />
            <keep-alive v-else>
              <router-view />
            </keep-alive> -->
            <!-- 2023-6-14 测试产品说去掉页签缓存 -->
            <router-view />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  queryList,
  updateSwitchFlagByApiPay,
  updateSwitchFlagByApiRemit,
  updateSwitchFlagByWebPay,
  updateSwitchFlagByWebRemit,
} from "@/api/manage/merchantManage/tradingSwitch";
import { countFailProcessingOrder } from "@/api/manage/orderManage/withdrawList";
import { Sidebar } from "./components/index.js";
import { tabs } from "./components/index.js";
import SvgIcon from "@/components/SvgIcon";
import SystematicNotification from "@/components/SystematicNotification/SystematicNotification";
export default {
  name: "Layout",
  components: {
    Sidebar,
    tabs,
    SystematicNotification,
    userName: "",
    SvgIcon,
  },
  data() {
    return {
      breadList: [],
      pathName: "",
      menuList: [],
      title: [],
      route_name: "",
      switchList: [], //业务开关
      failProcessingTotal: 0,
      loadingCountFail: false,
      switchRole: "systemManage:tradingSwitch", //交易开关权限
      countFailBtn: "home:withdrawList:countFailProcessingOrder",
    };
  },
  watch: {
    $route() {
      this.filterPath();
    },
  },
  created() {
    // console.log(this.$store.state.routers)
    this.menuList = this.$store.state.routers;
    this.userName = localStorage.getItem("userName");
    this.filterPath();
    if (
      this.ManageHost.indexOf(document.domain) > -1 &&
      this.outhHandle(this.switchRole)
    ) {
      //是否是总控后台
      this.getSwitchList(); //查询业务交易开关状态
      // 失败待退款订单统计
      this.countFailProcessingOrder();
    }
  },
  methods: {
    filterPath() {
      var menulist = this.menuList;
      let routeName = this.$route.name;
      this.route_name = this.$route.name;
      if (this.$route.name == "Home") {
        // this.title = this.$route.name
        this.title.length = 0;
        this.title.push("我的首页");
        return;
      }
      menulist.forEach((item) => {
        if (item.children && item.children.length) {
          var child = item.children.filter((vv) => vv.name === routeName);
          if (child.length) {
            // this.title = '我的首页' + ' / ' + item.meta.title + ' / ' + child[0].meta.title
            this.title.length = 0;
            this.title.push("我的首页");
            this.title.push(item.meta.title);
            this.title.push(child[0].meta.title);
          }
        } else {
          if (item.name === routeName) {
            // this.title = item.meta.title
            this.title.push(item.meta.title);
          }
        }
      });
      // console.log(this.$route)
    },
    routeClick() {
      // console.log(456789)
      this.$router.push({
        path: "/",
      });
    },
    goRoute() {
      this.$router.push("/");
    },
    goOut() {
      localStorage.setItem("userInfo", "");
      localStorage.setItem("codeList", "");
      this.$store.commit("clear_addRoles");
      this.$router.push("/login");
    },
    logoFun() {
      this.$router.push({
        path: "Home",
      });
    },
    // 查询业务交易开关状态
    getSwitchList() {
      queryList({ pageNo: 1, pageSize: 10 }).then((response) => {
        this.switchList = response.list;
        // 权限绑定
        this.switchList.forEach((item) => {
          if (item.switchName == "apiPay") {//启用禁用API代收
            this.$set(item, "role", "systemManage:updateSwitchFlag:ApiPay"); 
          }else if(item.switchName == "apiRemit") { //启用禁用API代付
            this.$set(item, "role", "systemManage:updateSwitchFlag:ApiRemit"); 
          }else if(item.switchName == "webPay") {//启用禁用后台充值
            this.$set(item, "role", "systemManage:updateSwitchFlag:WebPay"); 
          }else if(item.switchName == "webRemit") {//启用禁用后台下发
            this.$set(item, "role", "systemManage:updateSwitchFlag:WebRemit"); 
          }
        })
      });
    },
    changeSwitch(val, item) {
      let msg = !val
        ? "确定开启系统【" + item.remark + "】功能吗？"
        : "确定关闭系统【" +
          item.remark +
          "】功能吗？关闭后所有商户都不能创建该业务类型的订单！";
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const obj = {
            id: item.id,
            switchName: item.switchName,
            switchType: item.switchType,
            switchFlag: val,
          };
          let api = null;
          if (item.switchName == "apiPay") {
            //api代收
            api = updateSwitchFlagByApiPay;
          } else if (item.switchName == "apiRemit") {
            //api代付
            api = updateSwitchFlagByApiRemit;
          } else if (item.switchName == "webPay") {
            //后台充值
            api = updateSwitchFlagByWebPay;
          } else {
            //后台下发
            api = updateSwitchFlagByWebRemit;
          }
          api(obj).then((res) => {
            this.$message({ type: "success", message: "更新成功!" });
            // this.getSwitchList();
          });
        })
        .catch(() => {
          item.switchFlag = !item.switchFlag;
        });
    },
    // 统计失败待退款订单
    countFailProcessingOrder(opt) {
      this.loadingCountFail = true;
      countFailProcessingOrder().then((response) => {
        this.failProcessingTotal = response;
        this.loadingCountFail = false;
        if (opt === 1) {
          this.$message.success("刷新成功");
        }
      }).catch(() => {
        this.loadingCountFail = false;
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.layout {
  padding-left: 200px;
  .sidebar {
    width: 220px;
    // height: 100vh;
    // height: 100%;
    position: fixed;
    top: 120px;
    height: calc(100% - 120px);
    left: 10px;
    bottom: 0;
    overflow: auto;
    z-index: 1;
  }
  .breadcrumb-div {
    background: #232940;
    .container {
      width: 90%;
      max-width: 1580px;
      min-width: 1200px;
      margin: auto;
      padding: 0 20px;
      .breadcrumb {
        display: inline-block;
        font-size: 14px;
        line-height: 50px;
        margin-left: 10px;
        /deep/.el-breadcrumb {
          .el-breadcrumb__item {
            cursor: pointer !important;
            color: #fff !important;
            .el-breadcrumb__inner.is-link,
            .el-breadcrumb__inner {
              color: #fff !important;
            }
          }
        }
      }
    }
  }
  .main-container {
    // width: 90%;
    max-width: 100%;
    min-width: 800px;
    margin: auto;
    margin-top: 120px;
    background: #fff;
    .container-div {
      .tagsView {
        background: #ffffff;
        border: 1px solid #ddd;
        ul {
          margin: 8px 10px;
          li {
            /deep/.el-button > span > .el-icon-close {
              position: relative;
              right: -7px;
            }
            /deep/.el-button--primary {
              background: #4a95eb !important;
            }
          }
        }
      }
    }
    .container {
      margin: 0 5px;
    }
  }
  .layout-container {
    flex: 1;
    // background: #edf5f9;
    background: #f8f8f8;
    padding-left: 26px;
    padding-right: 10px;
  }
  .fixed-top {
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    // width: calc(100% - 220px);
    width: 100%;
  }
  .rightDiv {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    color: #979797;
    background: #ffffff;
    font-size: 14px;
    box-sizing: border-box;
    border-bottom: 1px solid #d9dadcad;
    i {
      font-size: 25px;
      color: #d8d8d8;
    }
    .latter {
      width: 52px;
    }
    .bell,
    .latter,
    .user,
    .avatar-wrapper:hover {
      cursor: pointer;
    }
    .bell,
    .latter {
      position: relative;
      top: 4px;
      .badge {
        position: relative;
        top: -10px;
        right: 15px;
        border: none;
        /deep/.el-badge .el-badge__content {
          border: none;
        }
      }
    }
    .user {
      display: flex;
      align-items: center;
      border-radius: 2px;
      padding: 5px 8px;
      font-size: 16px;
      color: #aeb9d8;
      .squert {
        width: 26px;
        height: 26px;
        border-radius: 50%;
        .user-img {
          width: 100%;
          height: 100%;
        }
      }
      .text {
        padding: 8px;
        font-size: 14px;
        color: #222222;
      }
    }
    .avatar-container {
      position: absolute;
      right: 25px;
      i {
        font-size: 8px;
      }
    }
  }
}

.bell {
  color: #fff;
  position: absolute !important;
  right: 120px;
  margin-top: -6px;
}
.system-switch {
  position: absolute !important;
  right: 120px;
  top: 50%;
  transform: translateY(-50%);

  .switch-item {
    display: inline-flex;
    align-items: center;
    margin: 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/layout.vue